// Builds the ActionCable consumer URL, appending the signed-in user's cable
// token when one is present. The live-tracking channels (LocationsChannel,
// FleetLocationsChannel) reject anonymous subscribers, so the web maps must
// carry the token minted server-side (ApplicationController#action_cable_token).
//
// @param {string} socketUrl - the base ActionCable URL
// @param {?string} token - the cable token, or null/undefined when signed out
// @returns {string} the URL with `?token=` appended when a token is given
export const cableUrlWithToken = (socketUrl, token) =>
  token ? `${socketUrl}?token=${encodeURIComponent(token)}` : socketUrl;
